import { Link } from 'react-router-dom';
import { FaMinus, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import { useCart } from './CartContext';

const currencyFormatter = new Intl.NumberFormat('es-CR', {
  style: 'currency',
  currency: 'CRC',
  maximumFractionDigits: 0,
});

const CartPreviewDrawer = () => {
  const {
    items,
    subtotal,
    isCartPreviewOpen,
    closeCartPreview,
    updateQuantity,
    removeItem,
    checkout,
  } = useCart();

  return (
    <div className={`cart-preview ${isCartPreviewOpen ? 'cart-preview--open' : ''}`} aria-hidden={!isCartPreviewOpen}>
      <button type="button" className="cart-preview-backdrop" aria-label="Cerrar carrito" onClick={closeCartPreview} />

      <aside className="cart-preview-panel" role="dialog" aria-modal="true" aria-labelledby="cart-preview-title">
        <div className="cart-preview-header">
          <h2 id="cart-preview-title">Carrito</h2>
          <button type="button" className="cart-preview-close" onClick={closeCartPreview}>
            <FaTimes /> Cerrar
          </button>
        </div>

        <div className="cart-preview-body">
          {items.length ? (
            items.map((item) => (
              <article className="cart-preview-item" key={item.cartKey}>
                <img src={item.image} alt={item.name} />
                <div className="cart-preview-item-info">
                  <h3>{item.name}</h3>
                  {item.options?.length ? <p>{item.options.join(' - ')}</p> : null}
                  <div className="cart-preview-quantity">
                    <button
                      type="button"
                      aria-label={`Restar ${item.name}`}
                      onClick={() => updateQuantity(item.cartKey, item.quantity - 1)}
                    >
                      <FaMinus />
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      type="button"
                      aria-label={`Sumar ${item.name}`}
                      onClick={() => updateQuantity(item.cartKey, item.quantity + 1)}
                      disabled={item.available !== null && item.available !== undefined && item.quantity >= item.available}
                    >
                      <FaPlus />
                    </button>
                    <strong>{currencyFormatter.format(item.price)}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="cart-preview-remove"
                  aria-label={`Quitar ${item.name}`}
                  onClick={() => removeItem(item.cartKey)}
                >
                  <FaTrash />
                </button>
              </article>
            ))
          ) : (
            <div className="cart-preview-empty">
              <h3>Tu carrito esta vacio</h3>
              <p>Agrega productos para preparar tu pedido.</p>
            </div>
          )}
        </div>

        <div className="cart-preview-footer">
          <div className="cart-preview-subtotal">
            <span>Subtotal:</span>
            <strong>{currencyFormatter.format(subtotal)}</strong>
          </div>
          <Link to="/carrito" className="cart-preview-action" onClick={closeCartPreview}>
            Ver carrito
          </Link>
          <button type="button" className="cart-preview-action" disabled={!items.length} onClick={checkout}>
            Finalizar compra
          </button>
          <p>Paga seguro al confirmar tu pedido.</p>
        </div>
      </aside>
    </div>
  );
};

export default CartPreviewDrawer;
